import { Stack, Icon } from '@fluentui/react';
import * as Api from '../api/src'
type StatusItemProps = {
  Status: Api.StatesEnum,
  Name: string
};

export const StatusItem = ({ Status, Name }: StatusItemProps) => {
  return (
    <>
      <Icon style={{color:Status == Api.StatesEnum.Active ? "#0aa252" : "#a9a8a6"}} iconName={Status == Api.StatesEnum.Active ? "SkypeCircleCheck" : "Blocked2Solid"}></Icon>&nbsp;{Name}
    </>
  );
};

